export default __webpack_public_path__ + "static/media/ProductDesign.14cef221.svg";